import { TCountryCode } from "@/types/app";
import { getCountryISO } from "@/utils/getCountryISO";
import { useQuery } from "@tanstack/react-query";
import { useSigninCheck } from "reactfire";
import useUserPlanData from "./useUserPlanData";

export const COUNTRY_ISO_QUERY_KEY = "user-country-iso";

type TUseCountryCode = {
  data?: TCountryCode;
  isLoading: boolean;
};

const useCountryCode = (): TUseCountryCode => {
  const { status: signinStatus, data: signinData } = useSigninCheck();
  const { data: planData, isInitialLoading: isLoadingPlan } = useUserPlanData();

  const isSignedIn = !!signinData?.signedIn;
  const isResolvingPlan =
    signinStatus === "loading" || (isSignedIn && isLoadingPlan);

  const planCountryCode = planData?.country_code;

  const geoQuery = useQuery({
    queryKey: [COUNTRY_ISO_QUERY_KEY],
    queryFn: getCountryISO,
    enabled: !planCountryCode && !isResolvingPlan,
  });

  const geoCountryCode = geoQuery.data as TCountryCode | undefined;

  const countryCode = planCountryCode ?? geoCountryCode;

  return {
    data: countryCode,
    isLoading: isResolvingPlan || geoQuery.isInitialLoading,
  };
};

export default useCountryCode;
